"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneDB = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
function cloneDB(db) {
    return {
        defaultSubQuestionType: db.defaultSubQuestionType,
        questions: cloneRecord(db.questions, cloneQuestion),
        lists: cloneRecord(db.lists, cloneList),
    };
}
exports.cloneDB = cloneDB;
exports.default = cloneDB;
function cloneRecord(r, cloner) {
    const newR = {};
    Object.keys(r).forEach(k => {
        newR[k] = cloner(r[k]);
    });
    return newR;
}
function cloneList(l) {
    return (0, cloneDeep_1.default)(l);
}
function cloneQuestion(q) {
    return (0, cloneDeep_1.default)(q);
}
